import { gql } from '@apollo/client';

export const REFRESH_TOKEN = gql`
  query refreshToken($refresh_token: String!) {
    refreshToken(refresh_token: $refresh_token) {
      access_token
    }
  }
`;
